export default "__VITE_ASSET__x2ieO6TY__"